import React, { useState } from "react";
import { toast } from "react-toastify";

function QuestionPage() {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    ward: "",
    mobile: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Ward → digits only
    if (name === "ward") {
      const onlyNums = value.replace(/\D/g, "");
      setForm({ ...form, ward: onlyNums });
      return;
    }

    // Mobile → digits only + max 10
    if (name === "mobile") {
      const onlyNums = value.replace(/\D/g, "").slice(0, 10);
      setForm({ ...form, mobile: onlyNums });
      return;
    }

    setForm({ ...form, [name]: value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (form.mobile.length !== 10) {
    toast.error("மொபைல் எண் 10 இலக்கமாக இருக்க வேண்டும் ❌");
    return;
  }

  setLoading(true); // START loading

  try {
    const res = await fetch(
      "https://tvk-backend-yl1b.onrender.com/api/complaints",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      }
    );

    const data = await res.json();

    if (data.success) {
      toast.success("உங்கள் குறை பதிவு செய்யப்பட்டது ✅");
      setForm({ name: "", ward: "", mobile: "", message: "" });
    } else {
      toast.error("சேமிக்க முடியவில்லை ❌");
    }
  } catch (err) {
    toast.error("Server error ❌");
    console.log(err);
  }

  setLoading(false); // STOP loading
};


  return (
    <>

      <div className="question-container">
        <h2>தங்களுடைய குறைகளை அனுப்பவும்</h2>

        <form onSubmit={handleSubmit} className="question-form">

          <input
            type="text"
            name="name"
            placeholder="பெயர்"
            value={form.name}
            onChange={handleChange}
            required
          />

          {/* Ward */}
          <input
            type="text"
            name="ward"
            placeholder="வார்டு எண்"
            value={form.ward}
            onChange={handleChange}
            inputMode="numeric"
            maxLength={4}
            required
          />

          {/* Mobile */}
          <input
            type="tel"
            name="mobile"
            placeholder="மொபைல் எண்"
            value={form.mobile}
            onChange={handleChange}
            inputMode="numeric"
            maxLength={10}
            required
          />

          <textarea
            name="message"
            placeholder="உங்கள் குறை / செய்தி"
            value={form.message}
            onChange={handleChange}
            required
          />

          <button type="submit" disabled={loading}>
            {loading ? (
              <span className="loader"></span>
            ) : (
              "அனுப்பவும்"
            )}
          </button>



        </form>
      </div>

    </>
  );
}

export default QuestionPage;
